import SentryTrackerInstance from './trackers/sentry';

class EncodingService {
  static hasNonIsoEncoding = (text: string): boolean => {
    return /[^\x00-\x7F]/.test(text);
  };

  static encodeIso88591 = (text: string): string => {
    return text.replace(/[^\u0000-\u00ff]/g, function (c) {
      return '&#' + c.charCodeAt(0) + ';';
    });
  };

  static handleEncoding = (text: string): string => {
    if (EncodingService.hasNonIsoEncoding(text)) {
      SentryTrackerInstance.trackError(
        { message: 'Non-ISO-8859-1 encoding detected' },
        {
          text: EncodingService.encodeIso88591(text),
        },
      );
      return EncodingService.encodeIso88591(text);
    }
    return text;
  };
}

export default EncodingService;
